import React from 'react';
import { PageToolbar } from '../common';

/**
 * WheelsHeader - Header component for Wheels page
 * Contains: page title, create button, toolbar with customer filter
 */
const WheelsHeader = ({
  viewMode,
  onToggleView,
  searchTerm,
  onSearchChange,
  onScan,
  statusFilter,
  onStatusFilterChange,
  customerFilter,
  onCustomerFilterChange,
  customers,
  onCreateClick,
  dateFilter,
  onDateFilterChange,
  onRefresh,
  isRefreshing,
  autoRefresh,
  onAutoRefreshChange
}) => {
  return (
    <div className="page-header">
      <div className="header-top">
        <h1>Wheels</h1>
        <div className="header-actions">
          <div className="refresh-controls">
            <button
              className={`refresh-btn${isRefreshing ? ' spinning' : ''}`}
              onClick={onRefresh}
              title="Refresh now"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="23 4 23 10 17 10"/>
                <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
              </svg>
            </button>
            <label className="auto-refresh-label">
              <input
                type="checkbox"
                checked={autoRefresh}
                onChange={(e) => onAutoRefreshChange(e.target.checked)}
              />
              Auto Refresh
              {autoRefresh && <span className="auto-refresh-dot" />}
            </label>
          </div>
          <button className="create-button" onClick={onCreateClick}>
            + Create Wheel
          </button>
        </div>
      </div>

      <PageToolbar
        viewMode={viewMode}
        onViewModeChange={onToggleView}
        searchTerm={searchTerm}
        searchPlaceholder="Search by wheel #, lot # or customer..."
        onSearchChange={onSearchChange}
        showScanButton={true}
        onScan={onScan}
      >
        <select
          className="filter-select"
          value={statusFilter}
          onChange={(e) => onStatusFilterChange(e.target.value)}
        >
          <option value="active">Active</option>
          <option value="converted">Converted</option>
          <option value="all">All Status</option>
        </select>
        <select
          className="filter-select"
          value={customerFilter}
          onChange={(e) => onCustomerFilterChange(e.target.value)}
        >
          <option value="all">All Customers</option>
          {customers.map(customer => (
            <option key={customer.id} value={customer.id}>
              {customer.name}
            </option>
          ))}
        </select>
        <div className="date-filter-wrapper">
          <input
            type="date"
            className="filter-date-input"
            value={dateFilter}
            onChange={(e) => onDateFilterChange(e.target.value)}
            title="Filter by date"
          />
          {dateFilter && (
            <button
              className="date-filter-clear"
              onClick={() => onDateFilterChange('')}
              title="Clear date filter"
            >
              ×
            </button>
          )}
        </div>
      </PageToolbar>
    </div>
  );
};

export default WheelsHeader;
